<template>
	<div class="d-flex justify-content-center h-100">
		<b-card title="Reset my password" style="max-width: 30rem" class="mt-5">
			<b-form @submit.prevent="resetPassword">
				<b-input-group class="mb-3">
					<b-input-group-prepend is-text>
						<b-icon icon="file-person-fill"></b-icon>
					</b-input-group-prepend>

					<b-form-input type="email" placeholder="E-Mail" v-model="Model.Email" required></b-form-input>

					<validatorian field="Email" :response="web_api_response" />
				</b-input-group>

				<b-input-group class="mb-3">
					<b-input-group-prepend is-text>
						<b-icon icon="file-lock-fill"></b-icon>
					</b-input-group-prepend>

					<b-form-input type="password" placeholder="Password" v-model="Model.NewPassword" required></b-form-input>

					<validatorian field="NewPassword" :response="web_api_response" />
				</b-input-group>

				<b-input-group class="mb-3">
					<b-input-group-prepend is-text>
						<b-icon icon="file-lock-fill"></b-icon>
					</b-input-group-prepend>

					<b-form-input type="password" placeholder="confirm Password" v-model="Model.ConfirmPassword" required></b-form-input>

					<validatorian field="ConfirmPassword" :response="web_api_response" />
				</b-input-group>

				<b-form-group>
					<b-button type="submit" variant="warning">Reset</b-button>
				</b-form-group>

				<p v-if="message">{{ message }}</p>
			</b-form>
		</b-card>
	</div>
</template>

<script>
import AccountService from '@/api-services/account.service';
import Validatorian from '@/components/partials/validatorian';

export default {
	data() {
		return {
			Model: {
				Code: '',
				Email: '',
				NewPassword: '',
				ConfirmPassword: ''
			},

			message: null,
			web_api_response: []
		};
	},

	components: {
		Validatorian
	},

	created() {
		if (this.$router.currentRoute.params.id) {
			this.Model.Code = this.$router.currentRoute.params.id;
		}
	},

	methods: {
		resetPassword() {
			this.validation_errors = [];
			AccountService.resetPassword(this.Model)
				.then((response) => {
					this.message = 'We have reset your password, please log in';
				})
				.catch((error) => {
					this.web_api_response = error.response.data;
					if (!this.web_api_response.ModelState) {
						this.message = error;
					}
				});
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/account/reset.vue